import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.5 13.666L4.69487 14.2181C5.45333 16.3671 5.83256 17.4416 6.69785 18.0538C7.56313 18.666 8.70258 18.666 10.9815 18.666H13.0185C15.2974 18.666 16.4369 18.666 17.3022 18.0538C18.1674 17.4416 18.5467 16.3671 19.3051 14.2181L19.5 13.666",
      stroke: "white",
      "stroke-opacity": "0.7",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.0052 5.33268V13.666M12.0052 5.33268C11.4217 5.33268 10.3315 6.9946 9.92188 7.41602M12.0052 5.33268C12.5887 5.33268 13.6789 6.9946 14.0885 7.41602",
      stroke: "white",
      "stroke-opacity": "0.7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }